import type { MeristemClientConfig } from "./pageDefinitions/types";

// Note explicitly not loading the timing module here to avoid init overhead
// as well as import cascades.
if (window.performance?.mark) {
  window.performance.mark("bf-exec-start");
}

// eslint-disable-next-line no-underscore-dangle
declare const __GROW_CONFIG__: Record<string, string>;

const injectedConfig = __GROW_CONFIG__;

/**
 * Template/HTML injections
 */

type NodeEnv = "production" | "staging" | "development" | "local" | "test";

const noomEnv = (injectedConfig.NOOM_ENV as NodeEnv) || "local";

export const appConfig = {
  NOOM_ENV: noomEnv,

  // Third-party *template* variables
  MIXPANEL_PROJECT_TOKEN: injectedConfig.MIXPANEL_PROJECT_TOKEN,
  ONE_TRUST_DOMAIN_ID: injectedConfig.ONE_TRUST_DOMAIN_ID,
  TALKABLE_SITE_ID: noomEnv === "production" ? "noom" : "noom-staging",
  API_DOMAIN: injectedConfig.API_DOMAIN || origin,
  USERPORTAL_URL:
    noomEnv === "production"
      ? "https://account.noom.com/"
      : "https://account.test.wsli.dev/",
  PATIENT_PORTAL_URL:
    noomEnv === "production"
      ? "https://healthcare.noom.com/"
      : "https://health.test.wsli.dev/",
  SENTRY_PROJECT_DSN_JS: injectedConfig.SENTRY_PROJECT_DSN_JS,
  BRAINTREE_TOKENIZATION_KEY: injectedConfig.BRAINTREE_TOKENIZATION_KEY,
  STRIPE_API_KEY: injectedConfig.STRIPE_API_KEY,
  RECAPTCHA_SITE_KEY: injectedConfig.RECAPTCHA_SITE_KEY,
  // Fallback to wp domain for localhost, proxied on other domains
  BLOG_DOMAIN: noomEnv === "local" ? "http://webnoomdev.wpengine.com" : "",

  TELEHEALTH_ENABLED: injectedConfig.TELEHEALTH_ENABLED !== "false",
  TELEHEALTH_BUYFLOW_THROTTLE: parseFloat(
    injectedConfig.TELEHEALTH_BUYFLOW_THROTTLE
  ),
  USE_SESSION_STORAGE_FOR_PLAN_TEMPORARY_FLAG:
    injectedConfig.USE_SESSION_STORAGE_FOR_PLAN_TEMPORARY_FLAG === "true",

  meristemConfig: (injectedConfig.meristemConfig || {}) as MeristemClientConfig,
} as const;
